import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { FakeText } from '@totalsoft/rocket-ui';

function FakeTextWrapper({ lines = 10, onPaper, sx }) {
  return (
    <Box sx={{ width: '100%', ...sx }}>
      <FakeText lines={lines} onPaper={onPaper} />
    </Box>
  );
}

FakeTextWrapper.propTypes = {
  lines: PropTypes.number,
  onPaper: PropTypes.bool,
  sx: PropTypes.object
};

export default FakeTextWrapper;
